import { useEffect } from "react"
import { getMsalInstance } from "../../../msalInstance"

const msalInstance = getMsalInstance()

export function Logout() {
  useEffect(() => {
    msalInstance.logoutRedirect()
  }, [])

  return <>Loggin out...</>
}
